<template>
    <div class="running-games-container">
        <my-servers-icon
            class="running-games-container__icon"
        ></my-servers-icon>
        <div class="running-games-container__logo-text">Running Games</div>
        <div class="running-games-container__title">
            My Servers
        </div>
        <div class="running-games-container__description">
            List of my servers - both rented via game and any official third
            party (aka Nitrado)
        </div>
    </div>
</template>

<script>
import MyServersIcon from 'Svgs/my-servers-icon.svg?inline';
export default {
    name: 'MyServers',
    components: {
        MyServersIcon,
    },
};
</script>

<style scoped lang="scss">
.running-games-container {
    display: grid;
    grid-template-columns: 4em 32rem minmax(400px, 1fr);
    grid-auto-rows: 6rem 4rem 4rem;
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-template-columns: repeat(3, 1fr);
    }
    &__icon {
        grid-column: 1;
        margin: 2rem auto auto 2rem;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 0 auto auto 1rem;
            grid-column: 1;
            grid-row: 1;
        }
    }
    &__logo-text {
        grid-column: 2;
        margin: 38px auto auto 2rem;
        width: 214px;
        height: 34px;
        color: $blue-main;
        font-family: $politica-font;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 1.03px;
        line-height: 53px;
        text-transform: uppercase;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 0.5rem auto auto 5rem;
            grid-column: 1;
            grid-row: 1;
            justify-self: center;
        }
    }
    &__title {
        grid-column: 1 / 2;
        grid-row: 2;
        margin-left: 3rem;
        width: 308px;
        height: 44px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: 0.57px;
        line-height: 53px;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin-left: 2rem;
            width: 239px;
            height: 25px;
            font-size: 30px;
            letter-spacing: 0.32px;
            line-height: 25px;
        }
    }
    &__description {
        grid-column: 1 / 4;
        grid-row: 3;
        margin-left: 3rem;
        width: 80%;
        height: 60px;
        color: $blue-main;
        font-family: $palanquin-font;
        font-size: 18px;
        font-weight: 400;
        line-height: 30px;
        @media (min-width: $xs-up) and (max-width: $xl-up) {
            grid-column: 1 / 3;
            width: 90%;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-column: 1 / 2;
            margin-left: 2rem;
            width: 90%;
        }
    }
}
</style>
